import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;

    > * {
        margin-bottom: 0.5rem;
    }
`;
